export default __webpack_public_path__ + "static/media/sprout.3a541192.svg";